import { faAddressCard } from '@fortawesome/pro-solid-svg-icons/faAddressCard';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBracketsCurly } from '@fortawesome/pro-solid-svg-icons/faBracketsCurly';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faChartPie } from '@fortawesome/pro-solid-svg-icons/faChartPie';
import { faDollarCircle } from '@fortawesome/pro-solid-svg-icons/faDollarCircle';
import { faGift } from '@fortawesome/pro-solid-svg-icons/faGift';
import { faHandHoldingUsd } from '@fortawesome/pro-solid-svg-icons/faHandHoldingUsd';
import { faHeartPulse } from '@fortawesome/pro-solid-svg-icons/faHeartPulse';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faPeopleArrows } from '@fortawesome/pro-solid-svg-icons/faPeopleArrows';
import { faProjectDiagram } from '@fortawesome/pro-solid-svg-icons/faProjectDiagram';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faRightToBracket } from '@fortawesome/pro-solid-svg-icons/faRightToBracket';
import { faRocket } from '@fortawesome/pro-solid-svg-icons/faRocket';
import { faRouter } from '@fortawesome/pro-solid-svg-icons/faRouter';
import { faSitemap } from '@fortawesome/pro-solid-svg-icons/faSitemap';
import { faSortAmountUp } from '@fortawesome/pro-regular-svg-icons/faSortAmountUp';
import { faTicketAlt } from '@fortawesome/pro-solid-svg-icons/faTicketAlt';
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faUserLock } from '@fortawesome/pro-solid-svg-icons/faUserLock';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';

export const levelsIcon = faSortAmountUp;
export const rewardsIcon = faGift;
export const earningRulesIcon = faProjectDiagram;
export const burningRulesIcon = faHandHoldingUsd;
export const editorIcon = faPalette;
export const incomingWebhooksIcon = faLink;
export const integrationsIcon = faSitemap;
export const referralCodesIcon = faPeopleArrows;
export const customKeysIcon = faBracketsCurly;
export const pushRulesIcon = faUpload;
export const reportIcon = faChartPie;
export const profilesIcons = faAddressCard;
export const eventReportsIcon = faHeartPulse;
export const domainsManagementIcon = faRouter;
export const superAdminIcon = faRocket;
export const testUsersIcon = faUserSecret;
export const programAccessIcon = faUserLock;
export const programLoginIcon = faRightToBracket;
export const blockedMemberIcon = faBan;
export const engageIcon = faBullhorn;
export const currenciesIcon = faDollarCircle;
export const loginPagesIcon = faRightToBracket;
export const interactionsIcon = faReceipt;
export const promoCodeIcon = faTicketAlt;
